module.exports = __webpack_public_path__ + "img/4.f4f2f255.png";